import { Card } from "@/components/ui/card";

export const HealthScoreOverview = () => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Health Score Overview</h3>
      <p className="text-muted-foreground">Overall health score metrics will appear here.</p>
    </Card>
  );
};